<template>
  <div class="data-list-container">
    <vs-table ref="table" max-items="10" search :data="datas">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base border"
          >
            <div class="centerx default-input">
              <vs-row>
                <vs-input
                  v-model="date_start"
                  type="date"
                  :format="'yyyy-mm-dd'"
                  class="inputx mr-2"
                  label="Date début"
                  :danger="formErrors.date_start ? true : false"
                  :danger-text="formErrors.date_start ? formErrors.date_start[0] : ''"
                  v-on:change="resetErrors('date_start')"
                />
                <vs-input
                  v-model="date_end"
                  type="date"
                  :format="'yyyy-mm-dd'"
                  class="inputx mr-2"
                  label="Date fin"
                  :danger="formErrors.date_end ? true : false"
                  :danger-text="formErrors.date_end ? formErrors.date_end[0] : ''"
                  v-on:change="resetErrors('date_end')"
                />
              </vs-row>
            </div>
          </div>
          <div
                  @click="getList(page)"
                  class="btn-add-new p-3 mb-1 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Rechercher</span>
          </div>
          <div
                  @click="Export()"
                  class="btn-add-new p-3 mb-1 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="DownloadCloudIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Exporter</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="login_date">Dernières connexions</vs-th>
        <vs-th sort-key="lastname">Nom</vs-th>
        <vs-th sort-key="firstname">Prénom</vs-th>
        <vs-th sort-key="team">Equipe</vs-th>
        <vs-th sort-key="agency">Agence</vs-th>
        <!-- <vs-th>Equipe</vs-th>
        <vs-th>Agence</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>{{ tr.login_date }}</vs-td>
            <vs-td>{{ tr.lastname }}</vs-td>
            <vs-td>{{ tr.firstname }}</vs-td>
            <vs-td>{{ tr.team }}</vs-td>
            <vs-td>{{ tr.agency }}</vs-td>

           <!--  <vs-td>{{ tr.user && tr.user.team ? tr.user.team.name : "---" }}</vs-td>

            <vs-td>{{ tr.user && tr.user.team && tr.user.team.agency ? tr.user.team.agency.name : "---" }}</vs-td>
           --></vs-tr>
        </tbody>
      </template>
    </vs-table>
    <br />
    <vs-row>
      <vs-col vs-offset="6" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { _buildQuery } from "../../helpers/buildquery";
import axios from "axios";

export default {
  name: "UserLoginByDay",
  data: () => ({
    datas: [],
    limit: 10,
    page: 1,
    last_page: null,
    url: "users-login",
    formErrors: {},
    date_start: "",
    date_end: "",
  }),
  watch: {
    page: function (value) {
      this.getList(value)
    }
  },
  methods: {
    getList(page) {
      const params = {
        page: page,
        limit: this.limit,
        date_start: this.date_start,
        date_end: this.date_end,
      };
      this.$vs.loading();
      this.$http
        .get(this.url + _buildQuery(params))
        .then((response) => {
          this.datas = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.data.status_code === 422) {
            //window.getApp.error(error)
            this.formErrors = error.response.data.errors;
            //console.log(this.formErrors)
          }
        });
    },
    async Export() {
      const params = {
        date_start: this.date_start,
        date_end: this.date_end,
        export_to: "xlsx"
      };
      this.$vs.loading()

      const response = await this.$http({
        url: '/export/users-login' + _buildQuery(params),
        method: 'GET',
        responseType: 'blob',
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'export_users_login.xlsx')
      document.body.appendChild(link)
      link.click()
      this.$vs.loading.close()
    },
    resetErrors(field) {
      if (field) {
        this.formErrors[field] = null;
      } else {
        this.formErrors = [];
        this.date_start = "";
        this.date_end = "";
      }
    },
  },
  mounted() {
    this.getList(this.page);
  },
};
</script>